<ng-container [ngSwitch]="library">
    <ng-template [ngSwitchCase]="'material'">
        <i class="material-icons"
           [pTooltip]="placeholder || null"
           tooltipPosition="top">
            {{ variant }}
        </i>
    </ng-template>
    <ng-template [ngSwitchCase]="'prime'">
        <i class="pi-prime {{variant}}"
           [pTooltip]="placeholder || null"
           tooltipPosition="top">
        </i>
    </ng-template>
    <ng-template [ngSwitchCase]="'fontawesome'">
        <i class="fa {{variant}}"
           [pTooltip]="placeholder || null"
           tooltipPosition="top"></i>
    </ng-template>
    <ng-template [ngSwitchCase]="'custom'">
        <i class="custom"
           [style.background]="computeCustomBackground()"
           [pTooltip]="placeholder || null"
           tooltipPosition="top"></i>
    </ng-template>
</ng-container>


